module.exports = __webpack_public_path__ + "img/thumbnail_GoliathBirdeater_u_normal.c7ff3085.png";